import { render, staticRenderFns } from "./UserBlockList.vue?vue&type=template&id=15194871&"
import script from "./UserBlockList.vue?vue&type=script&lang=ts&"
export * from "./UserBlockList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports